<template>
  <v-app id="inspire">
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      dark
    >
<!--      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->

      <v-toolbar-title
        style="width: 350px"
      >
        <span @click="goHome" class="white--text" style="text-decoration: none; cursor: pointer"><v-icon>mdi-truck</v-icon>&nbsp;TheShopFront</span>
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down pl-10 ml-4"
        v-model="userSearch"
        v-on:keyup="searchForProduct"
      />
      <v-spacer />
      <v-btn icon>
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
      <v-btn v-on="on" icon>
        <v-badge
          content="2"
          value="2"
          color="green"
          overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
      <v-btn v-on="on" @click="goToCart()" icon >
        <v-badge
          :class="cartCount? 'face': ''"
          :content="cartCount? cartCount: '0'"
          color="green"
          overlap
        >
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-bottom-navigation
        :value="activeBtn"
        color="primary"
        horizontal
      >
        <a @click="goHome" class="v-btn">
          <span>Home</span>
        </a>
      </v-bottom-navigation>
    </v-content>
      <router-view/>
    <v-footer
      :padless="true"
    >
      <v-card
        flat
        tile
        width="100%"
        class="secondary white--text text-center"
      >
        <v-card-text>
          <v-btn
            @click="goHome"
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-home</v-icon>
          </v-btn>
          <v-btn
            class="mx-4 white--text"
            icon
            href="mailto:hello@marvinkweyu.net"
          >
            <v-icon size="24px">mdi-email</v-icon>
          </v-btn>

        </v-card-text>

        <v-card-text class="white--text pt-0">
          {{ theShopFrontDesc }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>TheShopFront</strong>
          <br>
          <small> <a href="https://marvinkweyu.net" target="_blank" rel="noopener" class="marvin-profile">marvinkweyu</a> </small>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
    export default {
      data () {
        return {
          activeBtn: 1,
          userSearch: null,
          on: true,
          theShopFrontDesc: 'We are TheShopFront. An in-progress mock up e-commerce platform. ',
            }
        },
      methods:{
        searchForProduct(){
          this.$store.commit('setSearchTerm', this.userSearch)
        },
        goToCart(){
          this.$router.push('/cart')
        },
        goHome(){
          this.$router.push('/')
        }
      },
      computed: {
        cartCount(){
          return (this.$store.getters.cartItems).length
        }
      }
    }
</script>

<style >
 *{
    font-family: "Poppins", serif;
  }
  .marvin-profile{
    color: white !important;
    text-decoration: none;
  }
  .face {
  animation: shake 1.5s cubic-bezier(.36,.07,.19,.97) both;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  transform: translate3d(0, 0, 0);
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue